import {
  WORKSPACE_PANEL_NAMES,
  WorkspacePanelName,
} from 'features/libra/workspace/workspacePanelNames'
import { FC } from 'react'

import { Component as ActiveStepContent } from './ActiveStepContent'
import { Component as DocumentNavigationPanel } from './DocumentNavigationPanel'
import { Component as DocumentViewerPanel } from './DocumentViewerPanel'
import { Component as FfsAssetVizPanel } from './FfsAssetVizPanel'

/**
 * Runtime registry mapping panel names to their components. Indexed by the
 * names allowlist in `workspacePanelNames.ts`. Used by `WorkspaceLayoutRenderer`.
 */
export const WORKSPACE_PANEL_REGISTRY: Record<WorkspacePanelName, FC> = {
  ActiveStepContent,
  FfsAssetVizPanel,
  DocumentNavigationPanel,
  DocumentViewerPanel,
}

// Compile-time check that every name in the allowlist is registered.
const _exhaustiveness: ReadonlyArray<WorkspacePanelName> = WORKSPACE_PANEL_NAMES
void _exhaustiveness
